import React from 'react';
import classNames from 'classnames';
import { SubMenuItem as ReactSubMenuItem, MenuList } from 'react-menu-list';
import { DropdownMenu } from 'components/dropDownMenu/dropDownMenu';
import { BiArrowToRight as CaretIcon } from 'react-icons/bi';

import styles from 'components/nav/nav.module.scss';

export const SubMenu = ({ zIndex, menuItem, className, children }) => (
  <DropdownMenu>
    <ReactSubMenuItem
      menuZIndex={zIndex}
      highlightedStyle={{ background: '#d6edff' }}
      menu={
        <div className={classNames('submenu', styles.subMenu, className)}>
          <MenuList>{children}</MenuList>
        </div>
      }
    >
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="text-truncate pr-2" style={{ maxWidth: '90%' }}>{menuItem}</div>
        <CaretIcon size={16} style={{ flexShrink: 0, color: '#b5bdc2' }} />
      </div>
    </ReactSubMenuItem>
  </DropdownMenu>
);
